import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Videohero from "../components/videohero"

export default function Pagehero({
  src,
  alt,
  title_1,
  title_2,
  location,
  heroIntro,
}) {
  function hero() {
    if (location.pathname === "/") {
      return <Videohero />
    } else {
      return (
        <GatsbyImage
          alt={alt ? alt : "Great Bike Infrastructure Project hero image"}
          image={getImage(src.childrenImageSharp[0].gatsbyImageData)}
          placeholder="blurred"
          layout="fullWidth"
          className="object-cover inset-0 absolute w-full h-full z-0"
        />
      )
    }
  }

  return (
    <div className="relative h-[40vh] lg:h-[calc(100vh_-_122px)] w-full ">
      {hero()}
      <div className="text-white absolute flex flex-col justify-center items-center inset-0 text-center z-10 max-w-3xl mx-auto px-4">
        <h1 className="font-dharma font-bold text-6xl sm:text-8xl lg:text-10xl mb-2 sm:mb-6 lg:mb-4">
          {title_1 && <span className="block">{title_1}</span>}
          {title_2 && <span className="block">{title_2}</span>}
        </h1>
        {heroIntro && (
          <div className="text-base md:text-2xl leading-relaxed">
            {heroIntro}
          </div>
        )}
      </div>
    </div>
  )
}
